import React from "react";
import { Link } from "react-router-dom";
// import { StarIcon, LocationMarkerIcon } from '@heroicons/react/solid'; // Heroicons şimdilik kaldırıldı

const CompanyCard = ({ dealer }) => {
  // Gelen veriyi ve değişkenleri loglayalım
  console.log("CompanyCard - Gelen dealer:", dealer);
  const companyName = dealer?.dealer_name || "Bayi Adı Yok";
  const rating = dealer?.star_count || "0";
  const reviewCount = dealer?.comment_count || 0;
  const logo = dealer?.image_url; // Varsayılan logo kaldırıldı, API'den gelmezse boş kalacak
  // Açıklama API yanıtında yok, şimdilik sabit veya boş bırakabiliriz.
  const description =
    dealer?.description || `Profesyonel ${companyName} hizmetleri.`; // Örnek açıklama
  // Konum bilgisi API yanıtında yok, şimdilik kaldırıyoruz.
  // const location = dealer?.address_text || ...

  // Bayi adının baş harfini al
  const initial = companyName.charAt(0).toUpperCase();
  console.log("CompanyCard - Logo URL:", logo, "Initial:", initial);

  return (
    <Link
      to={`/dealer/${dealer.id}/products`}
      className="block w-full bg-white rounded-2xl border border-gray-200 p-4 sm:p-6 flex flex-col h-full shadow-sm hover:shadow-lg hover:border-indigo-300 transition-all duration-200"
    >
      {/* Logo ve Firma Adı */}
      <div className="flex items-start gap-3 mb-3">
        {/* Logo veya Baş Harf Alanı */}
        <div
          className="flex-shrink-0 flex items-center justify-center rounded-lg overflow-hidden"
          style={{ width: "58px", height: "58px" }}
        >
          {/* Logo URL'si varsa VE placeholder değilse logoyu göster, yoksa baş harfi */}
          {logo && !logo.includes("via.placeholder.com") ? (
            <img
              src={logo}
              alt={`${companyName} Logo`}
              className="w-full h-full object-contain"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center bg-indigo-100 text-indigo-600">
              <span className="text-2xl font-semibold">{initial}</span>
            </div>
          )}
        </div>
        <div className="flex-1 min-w-0">
          <h3
            className="text-base font-semibold text-[#111827] mb-1 truncate"
            title={companyName}
          >
            {companyName}
          </h3>
          {/* Konum bilgisi kaldırıldı */}
          {/* <div className="flex items-center gap-1 text-xs sm:text-sm text-gray-500"> ... </div> */}
        </div>
      </div>

      {/* Açıklama (varsa göster) */}
      {description && (
        <p
          className="text-xs sm:text-sm text-gray-500 mb-4 line-clamp-3 flex-grow"
          title={description}
        >
          {description}
        </p>
      )}

      {/* Rating */}
      <div className="flex items-center gap-1 text-sm mt-auto pt-4 border-t border-gray-100">
        {" "}
        {/* Üst border ve padding eklendi */}
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          className="w-4 h-4 text-[#6366F1]"
        >
          <path
            d="M7.52447 1.46352C7.67415 1.00287 8.32585 1.00287 8.47553 1.46353L9.9082 5.88836C9.97455 6.0903 10.1673 6.22811 10.3839 6.22811H15.0207C15.505 6.22811 15.7064 6.8466 15.3146 7.13836L11.5633 9.97408C11.3881 10.1056 11.3148 10.3361 11.3811 10.538L12.8138 14.9628C12.9635 15.4235 12.437 15.8039 12.0451 15.5121L8.29389 12.6764C8.11865 12.5449 7.88135 12.5449 7.70611 12.6764L3.95488 15.5121C3.56303 15.8039 3.03651 15.4235 3.18619 14.9628L4.61886 10.538C4.68521 10.3361 4.61191 10.1056 4.43667 9.97408L0.685441 7.13836C0.293584 6.8466 0.494972 6.22811 0.979333 6.22811H5.6161C5.83272 6.22811 6.02545 6.0903 6.0918 5.88836L7.52447 1.46352Z"
            fill="currentColor"
          />
        </svg>
        <span className="font-medium text-[#6366F1]">{rating}</span>
        <span className="text-[#6B7280]">({reviewCount} Değerlendirme)</span>
      </div>
    </Link>
  );
};

export default CompanyCard;
